export enum ToastStatus {
    Info = 'info',
    Warnig = 'warning',
    Success = 'success',
    Error = 'error',
    Loading = 'loading'
}

export enum ToastColorScheme {
    Info = 'info',
    Warnig = 'warn',
    Success = 'main',
    Error = 'error',
    Loading = 'info'
}